import { useEffect, useState } from "react";
import {
    Card,
    MenuItem,
    Select
} from "@mui/material";
import crudsService from "services/cruds-service";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import DownlinkForm from "./DownlinkForm";
import MDButton from "components/MDButton";
import { toast } from "react-toastify";

export default function DownlinkCommandsList({ model_id, device_id }) {
    const [commands, setCommands] = useState([]);
    const [selected, setSelected] = useState(null);
    const [values, setValues] = useState({})

    useEffect(() => {
        (async () => {
            let resp = await crudsService.getCommandsByModelId(model_id)
            if (resp.success) {
                setCommands(resp.data);
            }
        })()
    }, []);


    const updateDeviceSetting = async (e) => {
        e.preventDefault();
        let value = values;
        if(Object.keys(value).length === 0){
            if(!selected.input_variables?.value?.default){
                return toast.error('No values to update')
            }
            value = {value: selected.input_variables?.value?.default}
        }
        const payload = {
            command_id: selected.id,
            values: value,
            device_id
        }
        let resp = await crudsService.sendCommand(payload)
        if(resp.success){
            toast.success(resp.message)
        } else {
            toast.error(resp.message)
        }
    }
    if(!commands.length){
        return
    }

    return (
        <Card style={{ marginTop: '1rem' }}>
            <MDBox display="flex" flexDirection="column" px={3} my={2}>
                <MDTypography fontWeight="bold">Downlink Commands</MDTypography>
                <MDBox display="flex" mt={2} style={{ gap: '10px' }}>
                    <Select
                        id="selectCommand"
                        onChange={(e) => {
                            const selectedCmd = commands.find(
                                (cmd) => cmd.id === e.target.value
                            );
                            if (selectedCmd) {
                                setSelected(selectedCmd);
                            }
                        }}
                        sx={{
                            '& .MuiSelect-select': {
                                minHeight: '3em !important'
                            }
                        }}
                    >
                        <MenuItem value="" disabled>Select an command</MenuItem>
                        {commands.map((cmd) => (
                            <MenuItem key={cmd.id} value={cmd.id}>{cmd.command_name} - {cmd.command_type}</MenuItem>
                        ))}
                    </Select>
                    {
                        selected &&
                        <DownlinkForm command={selected} onValue={setValues} />
                    }
                </MDBox>
                <MDButton variant="gradient" color="dark" sx={{ width: '15%', marginTop: '20px' }} onClick={(e) => updateDeviceSetting(e)}>Send Update</MDButton>
            </MDBox>
        </Card>
    );
}
